import { Section, Text } from "@react-email/components";
import { twMerge } from "tailwind-merge";

export default function SquareIcon({ character, className }: { character: string, className?: string }) {
  return (
    <Section className={twMerge("bg-listflix-yellow-main rounded-md p-[4px] w-[30px] h-[30px]", className)}>
      <Text className="mb-[0px] mt-[0px] text-[18px] leading-[18px] text-white font-bold text-center">{character}</Text>
    </Section>
  )
}